
export const projects = [
  {
    title: "Clinica Nator",
    img: "https://github.com/luqui2/Sistema-Clinica-Medicaa./raw/main/Screens/Hospital.gif",
    demo: "",
    description: `"Sistema desktop para o gerenciamento de uma clínica medica.`,
    tags: ["#JAVA", "#SWING", "#SQL", "#HOSPITAL"],
    code: "https://github.com/LucasEsteves2/-Sistema-Clinica-Medica-",
  },
  {
    title: "Poke Story",
    link: "https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:6862539455694168064?compact=1",
    demo: "https://lucasesteves2.github.io/Pokemon-E-commerce-SERRATEC-/portal.html",
    description: `Aplicação para vendas e compras de produtos pokemon`,
    tags: ["#REACT", "#E-COMMERCE", "#POKEMON"],
    code: "https://github.com/LucasEsteves2/Pokemon-E-commerce-SERRATEC-",
  },
  {
    title: "Temporizador",
    img: "https://github.com/LucasEsteves2/Temporizador-JS/raw/main/temporizador.gif",
    demo: "https://lucasesteves2.github.io/Temporizador-JS/",
    description: `Gerencie seu tempo através de um timer`,
    tags: ["#REACT", "#STYLED-COMPONENTS", "#TIMER"],
    code: "https://github.com/LucasEsteves2/-SERRATEC-Temporizador",
  },
  {
    title: "Faeterj ",
    img: "https://raw.githubusercontent.com/LucasEsteves2/Site-Faeterj/main/src/backgroundGit.png",
    demo: "https://lucasesteves2.github.io/Site-Faeterj/index.html",
    description: `Site desenvolvido para a Faculdade de Tecnologia do Rio de Janeiro`,
    tags: ["#HTML", "#CSS", "#JAVASCRIPT"],
    code: "https://github.com/LucasEsteves2/Site-Faeterj",
  },  
  {
    title: "Pokedex",
    img: "https://shots.codepen.io/negus-marko/pen/ZEGzzgj-800.jpg?version=1580776834",
    demo: "https://lucasesteves2.github.io/PokeDex-/",
    description: `Lista de todos os pokemons consumindo a API Pokemon`,
    tags: ["#REACT", "#STYLED-COMPONENTS", "#TIMER"],
    code: "https://github.com/LucasEsteves2/PokeDex-",
  },
  {
    title: "API Ecommerce",
    img: "https://github.com/LucasEsteves2/ecommerce-API-Restful/blob/main/assets/aws.gif?raw=true",
    demo: "",
    description: `Api desenvolvida utilizando spring-boot, através dessa api é possivel fazer um crud completo de um produto e tambem adicionar imagens, todas as rotas são protegidas utilizando webtoken via jwt`,
    tags: ["#JAVA", "#SPRINGBOOT", "#AWS" ,"#JWT","#CRUD"],
    code: "https://github.com/LucasEsteves2/ecommerce-API-Restful",
  },
  {
    title: "Chat Lc",
    img: "https://github.com/LucasEsteves2/CHAT--NODE-SOCKET/blob/main/apresenta%C3%A7ao.gif?raw=true",
    demo: "",
    description: `Chat em tempo Real Utilizando Node.js`,
    tags: ["#NODE", "#WEBSOCKET", "#CHAT"],
    code: "https://github.com/LucasEsteves2/CHAT--NODE-SOCKET",
  },
  {
    title: "Clone Twitch",
    img: "https://f.hubspotusercontent40.net/hubfs/2974196/twitchmobileapp-imageonly.jpg",
    demo: "",
    description: `Clone do app Twitch-Tv `,
    tags: ["#REACTNATIVE", "#JAVASCRIPT", "#Twitch"],
    code: "https://github.com/LucasEsteves2/Twitch-Clone--ReactNative",
  },
  {
    title: "CHECK-INATOR",
    img: "https://github.com/LucasEsteves2/Sistema-Check-in/blob/main/src/imagens/Apresentacao.gif?raw=true",
    demo: "",
    description: `Sistema  de Viagens desenvolvido em Java utilizando swing`,
    tags: ["#JAVA", "#SWING", "#TRAVEL", "#TOURISM"],
    code: "https://github.com/LucasEsteves2/Sistema-Check-in",
  },  
  
  {
    title: "Curriculo em Tempo Real",
    img: "https://github.com/LucasEsteves2/Curriculo-Api-Github/blob/main/src/curriculo.png?raw=true",
    demo: "https://lucasesteves2.github.io/Curriculo-Api-Github/",
    description: "Curriculo criado em html + css consumindo a api do GitHub para atualizar o curriculo com os repositorios existentes",
    tags: ["#HTML", "#CSS", "#API", "#JAVASCRIPT"],
    code: "https://github.com/LucasEsteves2/Curriculo-Api-Github",
  },
  {
    title: "Brasileirão 2021",
    img: "https://github.com/LucasEsteves2/Dashboard-Brasileirao2021-PowerBi/raw/main/print.png",
    demo: "",
    description: `Projeto desenvolvido com Power bi, Tabela brasileirao 2021`,
    tags: ["#PowerBi"],
    code: "https://github.com/LucasEsteves2/Dashboard-Brasileirao2021-PowerBi",
  },
  {
    title: "Api NestJs + Docker",
    img: "https://repository-images.githubusercontent.com/180571949/1816f680-a221-11ea-8ae0-8d90df8436bb",
    demo: "https://github.com/LucasEsteves2/NestJs-API-DOCKER",
    description: `Api desenvolvida utilizando node e integração com DOCKER `,
    tags: ["#NODE", "#NESTJS", "#API", "#DOCKER"],
    code: "https://github.com/LucasEsteves2/NestJs-API-DOCKER",
  },
  {
    title: "Api LucasFlix",
    img: "https://i0.wp.com/drewchialauthor.com/wp-content/uploads/2014/01/3-lucasflix.jpg?fit=1306%2C979&ssl=1",
    demo: "https://github.com/LucasEsteves2/API-REST-FILMES.NET",
    description: `Api desenvolvida utilizando tecnologias e ferramentas como: .NET, EntityFramework, AutoMapper `,
    tags: ["#C#", "#ENTITY", "#API", "#ORM"],
    code: "https://github.com/LucasEsteves2/API-REST-FILMES.NET",
  },
];
